import { useStore } from 'effector-react'
import { requestCarFx } from '~/features/Inspection/model'
import {
  Defect,
  DefectDrawer,
  DefectRepairModal,
  inspectionFormModel,
  useDefect,
} from '~/entities/Inspection'
import { ProgressOverlay } from '~/shared/ui/Loaders'
import { PolygonMarkers } from '~/shared/ui/Polygon'
import carInteriorSvg from '~/shared/ui/Polygon/Images/carInterior.svg'
import { CAR_INTERIOR_POLYGONS } from './constants'

type InteriorMarkersProps = {
  defects: Defect[]
  onDefectsSet: (defects: Defect[]) => void
  canDefectRepair: boolean
}

export function InteriorMarkers({
  defects,
  onDefectsSet,
  canDefectRepair,
}: InteriorMarkersProps) {
  const isCarDetailsPending = useStore(
    inspectionFormModel.requestCarDetailsFx.pending,
  )
  const isCarDefectsPending = useStore(
    inspectionFormModel.requestDamagesInteriorFx.pending,
  )
  const isCarLoading = useStore(requestCarFx.pending)
  const carDetailsInteriorOptions = useStore(
    inspectionFormModel.$carDetailsInteriorOptions,
  )

  const {
    handleMarkerSelect,
    handleMarkerAdd,
    handleDefectDrawerClose,
    handleDrawerSuccess,
    isDefectDrawerShow,
    selectedDefect,
    markers,
    isDefectRepairModalShow,
    handleDefectModalClose,
    handleDefectRepair,
    handleDefectRepairCancel,
    newMarker,
    handleMarkerDelete,
  } = useDefect(defects, onDefectsSet)

  return (
    <>
      <ProgressOverlay
        loading={!isCarLoading && (isCarDetailsPending || isCarDefectsPending)}
      >
        <PolygonMarkers
          polygons={CAR_INTERIOR_POLYGONS}
          onMarkerSelect={handleMarkerSelect}
          onMarkerAdd={handleMarkerAdd}
          markers={markers}
          img={carInteriorSvg}
        />
      </ProgressOverlay>

      <DefectDrawer
        selectedDefect={selectedDefect}
        isShow={isDefectDrawerShow}
        onClose={handleDefectDrawerClose}
        onSuccess={handleDrawerSuccess}
        carDetailsOptions={carDetailsInteriorOptions}
        newMarker={newMarker}
        onDeleteMarker={handleMarkerDelete}
      />

      <DefectRepairModal
        selectedDefect={selectedDefect}
        isShow={isDefectRepairModalShow}
        onCancel={handleDefectModalClose}
        onRepairOk={handleDefectRepair}
        onRepairCancel={handleDefectRepairCancel}
        canRepair={canDefectRepair}
      />
    </>
  )
}
